<template>
  <div style="height: 100%">
    <div v-if="columnSettingsKey || $slots.toolbar" class="table-toolbar">
      <span class="table-toolbar-left">
        <slot name="toolbar"></slot>
      </span>
      <span v-if="columnSettingsKey" class="table-toolbar-right">
        <a-icon
          type="setting"
          class="table-column-settings-icon"
          @click="openColumnSettings"
        />
      </span>
    </div>
    <a-table
      :ellipsis="true"
      :loading="loading"
      :columns="displayColumns"
      :customRender="customRender"
      :data-source="tableData"
      bordered
      :scroll="{ x: 1200, y: 520 }"
      :rowKey="(record, index) => index"
      size="small"
      :customRow="onClickRow"
      :pagination="pagination"
      :rowClassName="rowClassName"
    >
    <!-- 首列序号 -->
    <template slot="index" slot-scope="scope">
      <!-- <template v-if="selectedRows && selectedRows[0] && record.blNo == selectedRows[0].blNo">
					<a-radio :checked="true"></a-radio>
				</template> -->
      <template>
        {{ scope }}
      </template>
    </template>
    <template slot="orderStatus" slot-scope="scope">
      {{ scope.value }}
    </template>

    <template slot="costTem" slot-scope="scope">
      <div style="width: 100%; text-align: right">
        <AmountText
          v-for="(item, index) of scope"
          :key="index"
          :value="item.price"
          :currency="item.currency"
        />
      </div>
    </template>

    <template slot="isDeclaration" slot-scope="scope">
      <span v-if="scope !== null">{{ scope == true ? $t("yes") : $t("no") }}</span>
    </template>

    <template slot="trackStatus" slot-scope="scope, record">
      <span v-if="record.trackStatus">{{ record.trackStatus.msg }}</span>
    </template>

    <template slot="boundType" slot-scope="scope">
      {{ scope.msg }}
    </template>
    <template slot="receivableBoundType" slot-scope="scope">
      {{ $t(boundTypeMap[scope.code]) }}
    </template>
    <template slot="locationType" slot-scope="scope">
      {{ scope.value }}
    </template>
    <template slot="factoryAddress" slot-scope="scope, record">
      <span v-if="record.factoryAddress">
        <span v-for="(item, index) in record.factoryAddress.split(',')" :key="index"
          >{{ item }} <br />
        </span>
      </span>
    </template>
    <template slot="locationContactName" slot-scope="scope, record">
      <span v-if="record.locationContactName">
        <span v-for="(item, index) in record.locationContactName.split(',')" :key="index"
          >{{ item }} <br />
        </span>
      </span>
    </template>
    <template slot="locationContactPhone" slot-scope="scope, record">
      <span v-if="record.locationContactPhone">
        <span v-for="(item, index) in record.locationContactPhone.split(',')" :key="index"
          >{{ item }} <br />
        </span>
      </span>
    </template>

    <template slot="factoryContactName" slot-scope="scope, record">
      <span v-if="record.factoryContactName">
        <span v-for="(item, index) in record.factoryContactName.split(',')" :key="index"
          >{{ item }} <br />
        </span>
      </span>
    </template>

    <template slot="factoryContactPhone" slot-scope="scope, record">
      <span v-if="record.factoryContactPhone">
        <span v-for="(item, index) in record.factoryContactPhone.split(',')" :key="index"
          >{{ item }} <br />
        </span>
      </span>
    </template>

    <template slot="edit" slot-scope="scope, record">
      <slot name="option" v-bind:driver="record"> </slot>
    </template>
    <template slot="editLocation" slot-scope="scope, record">
      <slot name="option" v-bind:driver="record"> </slot>
    </template>
    <template slot="editCustomer" slot-scope="scope, record">
      <slot name="option" v-bind:driver="record"> </slot>
    </template>
    <template slot="updateTruck" slot-scope="scope, record">
      <slot name="option" v-bind:truck="record"></slot>
    </template>

    <template slot="seeAttachement" slot-scope="scope, record">
      <slot name="option" v-bind:attach="record"></slot>
    </template>

    <template slot="popover" slot-scope="scope, record">
      <a-tooltip
        :title="record.remark"
        placement="left"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        overlayClassName="popovername"
      >
        <span>{{ record ? record.remark : "" }}</span>
      </a-tooltip>
    </template>
  </a-table>
    <a-modal
      :visible="columnSettingsVisible"
      :title="$t('columnSettings.title')"
      :width="480"
      :mask-closable="false"
      :body-style="{ maxHeight: '60vh', overflowY: 'auto', paddingRight: '16px' }"
      @cancel="closeColumnSettings"
    >
      <draggable
        :list="editingItems"
        :animation="150"
        item-key="key"
      >
        <div
          v-for="item in editingItems"
          :key="item.key"
          class="column-settings-row"
          :class="{ 'row-hidden': item.hidden }"
        >
          <a-checkbox
            :checked="!item.hidden"
            @change="(e) => onToggleColumn(item.key, e.target.checked)"
          >
            {{ item.title }}
          </a-checkbox>
        </div>
      </draggable>
      <template slot="footer">
        <a-button @click="closeColumnSettings">{{ $t('columnSettings.cancel') }}</a-button>
        <a-button type="primary" @click="saveColumnSettings">{{ $t('columnSettings.ok') }}</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import AmountText from "../../components/AmountText.vue";
import { boundTypeMap } from "../../constant";
import {
  getColumnSettings,
  setColumnSettings,
  mergeColumns,
} from "@/utils/column-settings";
export default {
  name: "table-fixed",
  components: {
    AmountText,
    draggable,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    tableColumn: {
      type: Array,
      default() {
        return [];
      },
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    isSelect: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default() {
        return {};
      },
    },
    columnSettingsKey: {
      type: String,
      default: "",
    },
    lockedColumnKeys: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      isActive: true,
      boundTypeMap,
      columnSettingsVisible: false,
      editingItems: [],
      settingsVersion: 0,
    };
  },
  computed: {
    displayColumns() {
      // eslint-disable-next-line no-unused-vars
      const _v = this.settingsVersion;
      const settings = getColumnSettings(this.columnSettingsKey);
      return mergeColumns(this.tableColumn, settings, this.lockedColumnKeys);
    },
  },
  watch: {
    tableData() {
      console.log(
        "this.tableData is changed === ",
        this.tableData,
        this.selectedRowKeys,
        this.selectedRows
      );
      this.selectedRowKeys = [];
      this.selectedRows = [];
      // 通知父单元情况选择数据
      this.selectChanged([]);
    },
    loading: {
      handler() {
        this.isActive = !this.loading;
      },
    },
  },
  created() {},
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      console.log("selectedRowKeys changed: ", selectedRowKeys, selectedRows);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
      this.selectChanged(selectedRows);
    },
    // 点击一行实现选中
    onClickRow(record, index) {
      return {
        on: {
          click: () => {
            console.log("行事件", record, index);
            this.selectedRowKeys = [index];
            this.selectedRows = [record];
            this.selectChanged(this.selectedRows);
          },
          dblclick: () => {
            console.log("双击此行", record, index);
            this.selectedRowKeys = [index];
            this.selectedRows = [record];
            this.$emit("dbclickRow", this.selectedRows);
          },
          mouseenter: () => {
            this.rowClassName;
          }, // 鼠标移入行
        },
      };
    },
    rowClassName(record) {
      if (
        this.selectedRows &&
        this.selectedRows[0] &&
        record.index == this.selectedRows[0].index
      ) {
        return "ant-select-row";
      }
      return "";
    },
    // 通知父单元选择项发生变化
    selectChanged(selectedRows) {
      this.$emit("onSelectChange", selectedRows);
    },
    columnKeyOf(c) {
      if (c && typeof c.dataIndex === "string" && c.dataIndex !== "") return c.dataIndex;
      if (c && typeof c.title === "string" && c.title !== "") return c.title;
      return null;
    },
    columnTitleOf(c) {
      if (!c) return "";
      if (typeof c.title === "string") return c.title;
      return c.dataIndex || "";
    },
    buildEditingItems() {
      const settings = getColumnSettings(this.columnSettingsKey);
      const hiddenSet = new Set(settings.hidden);
      const lockedSet = new Set(this.lockedColumnKeys);
      const configurableCols = this.tableColumn.filter((c) => {
        const k = this.columnKeyOf(c);
        return k !== null && !lockedSet.has(k);
      });
      const order = settings.order && settings.order.length > 0
        ? settings.order
        : configurableCols.map((c) => this.columnKeyOf(c));
      const keyToCol = new Map();
      configurableCols.forEach((c) => {
        const k = this.columnKeyOf(c);
        if (k !== null) keyToCol.set(k, c);
      });
      const seen = new Set();
      const items = [];
      order.forEach((k) => {
        if (keyToCol.has(k) && !seen.has(k)) {
          seen.add(k);
          items.push({
            key: k,
            title: this.columnTitleOf(keyToCol.get(k)),
            hidden: hiddenSet.has(k),
          });
        }
      });
      configurableCols.forEach((c) => {
        const k = this.columnKeyOf(c);
        if (k !== null && !seen.has(k)) {
          seen.add(k);
          items.push({
            key: k,
            title: this.columnTitleOf(c),
            hidden: hiddenSet.has(k),
          });
        }
      });
      return items;
    },
    openColumnSettings() {
      this.editingItems = this.buildEditingItems();
      this.columnSettingsVisible = true;
    },
    closeColumnSettings() {
      this.columnSettingsVisible = false;
      this.editingItems = [];
    },
    onToggleColumn(key, checked) {
      const item = this.editingItems.find((i) => i.key === key);
      if (item) this.$set(item, "hidden", !checked);
    },
    saveColumnSettings() {
      setColumnSettings(this.columnSettingsKey, {
        order: this.editingItems.map((i) => i.key),
        hidden: this.editingItems.filter((i) => i.hidden).map((i) => i.key),
      });
      this.settingsVersion++;
      this.columnSettingsVisible = false;
      this.editingItems = [];
    },
  },
};
</script>
<style lang="less">
.ant-select-row {
  background-color: #cbf2ff;
}
</style>
<style scoped lang="less">
.table-toolbar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 8px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
}
.table-toolbar-left {
  grid-column: 2;
  display: flex;
  align-items: center;
  gap: 8px;
}
.table-toolbar-right {
  grid-column: 3;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.table-column-settings-icon {
  font-size: 16px;
  cursor: pointer;
  color: #888;
}
.table-column-settings-icon:hover {
  color: #1890ff;
}
.column-settings-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  border: 1px solid #e8e8e8;
  margin-bottom: 4px;
  background: #fff;
  cursor: grab;
  user-select: none;
}
.column-settings-row:hover {
  border-color: #1890ff;
}
.column-settings-row:active {
  cursor: grabbing;
}
.column-settings-row.row-hidden {
  opacity: 0.5;
  background: #fafafa;
}
</style>
